'use client';

/* eslint-disable @next/next/no-img-element */
import { c as _c } from "react/compiler-runtime";
import { styled, useTheme, useMediaQuery } from '@mui/material';
import type { ReactNode } from 'react';
interface ImageObj {
  src: string;
  alt?: string;
  className?: string;
  height?: number;
  width?: number;
}
interface IllustrationsProp {
  image1?: ReactNode | ImageObj;
  image2?: ReactNode | ImageObj;
  maskImg?: ReactNode | ImageObj;
}

// Styled Components
const MaskImg = styled('img')({
  inlineSize: '100%',
  position: 'absolute',
  insetBlockEnd: 0,
  zIndex: -1
});
const Illustrations = props => {
  const $ = _c(13);
  const {
    image1,
    image2,
    maskImg
  } = props;
  const theme = useTheme();
  let t0;
  if ($[0] !== theme.breakpoints) {
    t0 = theme.breakpoints.down("md");
    $[0] = theme.breakpoints;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hidden = useMediaQuery(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function isImageObj(obj) {
      return !!obj && typeof obj === "object" && "src" in obj;
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isImageObj = t1;
  if (!hidden) {
    let t2;
    if ($[3] !== image1) {
      t2 = typeof image1 === "undefined" || isImageObj(image1) ? <img alt={image1?.alt || "tree-1"} src={image1?.src || "/statics/images/illustrations/objects/tree-1.png"} className={image1?.className || "absolute inline-start-0 block-end-0"} width={image1?.width} height={image1?.height || 200} /> : image1;
      $[3] = image1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== maskImg) {
      t3 = typeof maskImg === "undefined" || isImageObj(maskImg) ? <MaskImg alt={maskImg?.alt || "mask"} src={maskImg?.src || "/statics/images/pages/misc-mask-light.png"} className={maskImg?.className} width={maskImg?.width} height={maskImg?.height} /> : maskImg;
      $[5] = maskImg;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== image2) {
      t4 = typeof image2 === "undefined" || isImageObj(image2) ? <img alt={image2?.alt || "tree-2"} src={image2?.src || "/statics/images/illustrations/objects/tree-2.png"} className={image2?.className || "absolute inline-end-0 block-end-0"} width={image2?.width} height={image2?.height || 200} /> : image2;
      $[7] = image2;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
      t5 = <>{t2}{t3}{t4}</>;
      $[9] = t2;
      $[10] = t3;
      $[11] = t4;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    return t5;
  } else {
    return null;
  }
};
export { Illustrations };